import React from "react";

import "./tokenRelease.scss";
import diagramImg from "../../assets/imgs/tokenRelease/diagram.png";
import ImgList from "../ImgList";
import { listedImg } from "../../assets/Data/Release";

const TokenRelease = () => {
    return (
        <section className="container bgWhite release ">
            <div className="grid wide">
                <div className="release__schedule">
                    <h3 className="textBox__title">Token Release Schedule</h3>
                    <div className="diagramImg">
                        <img src={diagramImg} alt="diagram" />
                    </div>
                </div>

                <ImgList title="DOSE is listed on" listImg={listedImg} />
            </div>
        </section>
    );
};

export default TokenRelease;
